import { throttle } from 'lodash';
import { MarketDataProvider } from '@/api';

const debug = process.env.NODE_ENV !== 'production';

export default function createWebSocketPlugin() {
  const marketDataProvider = new MarketDataProvider();
  const throttleTime = debug ? 1000 : 100;
  return (store: any) => {
    // Bitfinex
    marketDataProvider.bitfinex.on(
      'orderbook',
      throttle((orderbook) => {
        store.commit('bitfinex/UPDATE_ORDERBOOK', orderbook);
      }, throttleTime),
    );
    marketDataProvider.bitfinex.on(
      'subscribeStatus',
      throttle((status) => {
        store.commit('bitfinex/SUBSCRIBE_STATUS', status);
      }, throttleTime),
    );
    marketDataProvider.bitfinex.on(
      'ticker',
      throttle((ticker) => {
        store.commit('bitfinex/UPDATE_TICKER', ticker);
      }, throttleTime),
    );
    marketDataProvider.bitfinex.on(
      'btcTicker',
      throttle((btcTicker) => {
        store.commit('bitfinex/UPDATE_BTC_TICKER', btcTicker);
      }, throttleTime),
    );
    marketDataProvider.bitfinex.on(
      'usdTicker',
      throttle((usdTicker) => {
        store.commit('bitfinex/UPDATE_USD_TICKER', usdTicker);
      }, throttleTime),
    );
    store.subscribe((mutation: any) => {
      if (mutation.type === 'bitfinex/SET_FACTOR') {
        marketDataProvider.bitfinex.setFactor(mutation.payload);
      }
    });

    // Bitflyer
    marketDataProvider.bitflyer.on(
      'orderbook',
      throttle((orderbook) => {
        store.commit('bitflyer/UPDATE_ORDERBOOK', orderbook);
      }, throttleTime),
    );
    marketDataProvider.bitflyer.on(
      'ticker',
      throttle((ticker) => {
        store.commit('bitflyer/UPDATE_TICKER', ticker);
      }, throttleTime),
    );
    marketDataProvider.bitflyer.on(
      'spotTicker',
      throttle((spotTicker) => {
        store.commit('bitflyer/UPDATE_SPOT_TICKER', spotTicker);
      }, throttleTime),
    );

    // BitMEX
    marketDataProvider.bitmex.on(
      'orderbook',
      throttle((orderbook) => {
        store.commit('bitmex/UPDATE_ORDERBOOK', orderbook);
      }, throttleTime),
    );
    marketDataProvider.bitmex.on(
      'ticker',
      throttle((ticker) => {
        store.commit('bitmex/UPDATE_TICKER', ticker);
      }, throttleTime),
    );
    marketDataProvider.bitmex.on(
      'funding',
      throttle((funding) => {
        store.commit('bitmex/UPDATE_FUNDING', funding);
      }, throttleTime),
    );

    // MarketDataProvider
    marketDataProvider.on('trades',
      throttle((exchangeTrades) => {
        store.commit('exchangeTrades/UPDATE_TRADES', exchangeTrades);
      }, throttleTime),
    );
    // marketDataProvider.on('alert',
    //   throttle(() => {

    //   }, throttleTime),
    // );
  };
}
